export class PreparationBasic {

    private active: boolean;
    private code: string;
    private description: string;
    private image: string;
    private internalId: string;

    constructor(active?: boolean, code?: string, description?: string, image?: string, internalId?: string) {
        this.active = active;
        this.code = code;
        this.description = description;
        this.image = image;
        this.internalId = internalId;
    }

    public get Active(): boolean {
        return this.active;
    }

    public set Active(active: boolean) {
        this.active = active;
    }

    public get Code(): string {
        return this.code;
    }

    public set Code(code: string) {
        this.code = code;
    }

    public get Description(): string {
        return this.description;
    }

    public set Description(description: string) {
        this.description = description;
    }

    public get Image(): string {
        return this.image;
    }

    public set Image(image: string) {
        this.image = image;
    }

    public get InternalId(): string {
        return this.internalId;
    }

    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
}